import React from "react";

interface TokenHoverTooltipProps {
  name: string;
  description: string;
  screenX: number;
  screenY: number;
}

const TokenHoverTooltip = React.memo(function TokenHoverTooltip({
  name,
  description,
  screenX,
  screenY,
}: TokenHoverTooltipProps) {
  const truncated =
    description.length > 80 ? description.slice(0, 80) + "…" : description;

  return (
    <div
      className="token-hover-tooltip"
      style={{
        position: "fixed",
        left: screenX + 12,
        top: screenY + 12,
        zIndex: 'var(--z-toast)',
        pointerEvents: "none",
      }}
    >
      <div className="font-semibold text-ui text-fg">{name}</div>
      {truncated && (
        <div className="text-meta text-muted-foreground mt-0.5">{truncated}</div>
      )}
    </div>
  );
});
export default TokenHoverTooltip;
